import React, { FC } from 'react';

import { ModalGridItem } from 'components/molecules';
import { useLocale } from 'lib';
import { mdiCassette } from '@mdi/js';
import type { ContactOptionModalItemProps } from '..';

export const AutomaticPhoneMessageOption: FC<ContactOptionModalItemProps> = () => {

  const { t } = useLocale();

  return (
    <ModalGridItem
      iconPath={mdiCassette}
      label={t('Alarm_Detail_Contact.Automatic_Phone_Message.Title')}
      subtitle={t('Alarm_Detail_Contact.Automatic_Phone_Message.Subtitle')}
      onClick={null}
    />
  );

};
